'use client';
import { createTranslation } from '@components/Translation/utils';
import React from 'react';

export interface TranslationConfig {
  defaultNS: string;
}

export interface TranslationContext {
  lang?: string;
  namespaces?: Record<string, any>;
  config?: TranslationConfig;
}

export const InternalTranslationContext = React.createContext<TranslationContext>({});

export const useTranslation = (namespace?: string) => {
  const { namespaces, lang, config } = React.useContext(InternalTranslationContext);
  return {
    t: createTranslation(namespaces?.[namespace ?? config?.defaultNS ?? 'common'] ?? {}),
    lang,
  };
};

export interface ProviderProps {
  children: React.ReactNode;
  namespaces: Record<string, any>;
  lang: string;
  config: TranslationConfig;
}
export const InternalTranslationProvider = ({
  children,
  namespaces,
  lang,
  config,
}: ProviderProps) => (
  <InternalTranslationContext.Provider value={{ lang, namespaces, config }}>
    {children}
  </InternalTranslationContext.Provider>
);
